const defaultState = {
  variant: '',
  message: '',
  position: '',
  show: false,
  duration: 0
}

export default function reducer(state=defaultState, action) {

    switch (action.type) {
      case "SHOW_SNACKBAR": {
        return {
          ...state,
          show: true,
          message: action.payload.message,
          variant: action.payload.variant,
          verticalPosition: action.payload.verticalPosition,
          horizontalPosition: action.payload.horizontalPosition,
          duration: action.payload.duration
        }
      }
      case "HIDE_SNACKBAR": {
        return {
          ...state,
          show: false,
          message: ''
        }
      }
      default:{
        return state
      }
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/snackbarReducer.js